import divisionData from './china-administrative-divisions.json'

export type DistrictOption = { code: string, name: string }
export type CityOption = { code: string, name: string, children: DistrictOption[] }
export type ProvinceOption = { code: string, name: string, children: CityOption[] }

export type RegionSelection = {
  provinceCode: string
  cityCode: string
  districtCode: string
}

export const emptyRegionSelection: RegionSelection = {
  provinceCode: '', cityCode: '', districtCode: '',
}

export const industryOptions = [
  '农、林、牧、渔业',
  '采矿业',
  '制造业',
  '电力、热力、燃气及水生产和供应业',
  '建筑业',
  '批发和零售业',
  '交通运输、仓储和邮政业',
  '住宿和餐饮业',
  '信息传输、软件和信息技术服务业',
  '金融业',
  '房地产业',
  '租赁和商务服务业',
  '科学研究和技术服务业',
  '水利、环境和公共设施管理业',
  '居民服务、修理和其他服务业',
  '教育',
  '卫生和社会工作',
  '文化、体育和娱乐业',
  '公共管理、社会保障和社会组织',
  '国际组织',
  '其他',
] as const

// Static PCA data pinned to modood/Administrative-divisions-of-China@c49d495b40ac73eb1a66f6eeae5f8fd10696f035.
export const chinaAdministrativeDivisions = divisionData as ProvinceOption[]

export function formatRegion(selection: RegionSelection) {
  const province = chinaAdministrativeDivisions.find(item => item.code === selection.provinceCode)
  const city = province?.children.find(item => item.code === selection.cityCode)
  const district = city?.children.find(item => item.code === selection.districtCode)
  return province && city && district ? `${province.name} / ${city.name} / ${district.name}` : ''
}

export function resolveRegion(region?: string): RegionSelection {
  if (!region?.trim()) return emptyRegionSelection
  const province = chinaAdministrativeDivisions.find(item => region.includes(item.name))
  if (!province) return emptyRegionSelection
  const city = province.children.find(item => region.includes(item.name))
    || (province.children.length === 1 ? province.children[0] : undefined)
  const district = city?.children.find(item => region.includes(item.name))
  if (!city || !district) return emptyRegionSelection
  return { provinceCode: province.code, cityCode: city.code, districtCode: district.code }
}
